import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Message,
  Grid,
  Row,
  Col,
  Container,
  Header,
  Content,
  Footer,
  Sidebar,
  Table,
  Icon,
  FlexboxGrid,
  IconButton,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import TableBackList from '../tableBlacklist/TableBackList'
import TableProjectHistoryForResponsible from '../tableProjectHistoryForResponsible/TableProjectHistoryForResponsible'
import TableProjectSummary from '../tableProjectSummary/TableProjectSummary'
import './styles.less'

export default function GranteeProfileInfo({ schema, showCommandButton }) {
  const [formSchema, setFormSchema] = useState(schema)
  const [sectionA, setSectionA] = useState()
  const [sectionB, setSectionB] = useState()
  const [sectionC, setSectionC] = useState()
  const [isLoading, setIsLoading] = useState(false)

  return (
    <>
      <Panel
        className="grantee-profile-info"
        shaded
        header={formSchema.granteeProfileHeader}
        bordered
        collapsible
        defaultExpanded
      >
        <Container>
          <Header>
            <h3>{schema.granteeProfile.granteeName}</h3>
          </Header>
          <br />
          <Container>
            <Sidebar width={200} className="side-bar-info">
              <img
                style={{
                  width: 'inherit',
                  border: '1px solid #e5e5ea',
                  borderRadius: 6,
                  marginBottom: 15,
                }}
                src={
                  'https://st.depositphotos.com/2101611/3925/v/600/depositphotos_39258143-stock-illustration-businessman-avatar-profile-picture.jpg'
                }
              ></img>
              <IconButton
                style={{ marginBottom: 5 }}
                icon={<Icon appearance="ghost" icon="info-circle" />}
                onClick={() =>
                  scrollToComponent(sectionA, { offset: -20, align: 'top', duration: 500 })
                }
              >
                {schema.blacklistStatus}
              </IconButton>
              <IconButton
                style={{ marginBottom: 5 }}
                icon={<Icon appearance="ghost" icon="book" />}
                onClick={() =>
                  scrollToComponent(sectionB, { offset: -20, align: 'top', duration: 500 })
                }
              >
                {schema.progressSummary}
              </IconButton>
              <IconButton
                style={{ marginBottom: 5 }}
                icon={<Icon appearance="ghost" icon="sitemap" />}
                onClick={() =>
                  scrollToComponent(sectionC, { offset: -20, align: 'top', duration: 500 })
                }
              >
                {schema.progressHistory}
              </IconButton>
            </Sidebar>

            <Container className="grantee-profile-info__container">
              <Content className="grantee-profile-info__content">
                <Panel bordered style={{ padding: 10, marginRight: 5, height: '99%' }}>
                  <Row style={{ paddingTop: '10%', paddingBottom: '10%' }}>
                    <Col xs={18} sm={19} md={24} className="text-col">
                      <strong className="title">{schema.granteeProfile.granteeNameTitle} : </strong>
                      {schema.granteeProfile.granteeName}
                    </Col>

                    {/* <Col xs={18} sm={19} md={24} className="text-col">
                      <strong className="title">
                        {schema.granteeProfile.granteeNameTitleEN} :{' '}
                      </strong>
                      {schema.granteeProfile.granteeNameEN}
                    </Col> */}

                    {/* <Col xs={18} sm={19} md={24} className="text-col">
                      <strong className="title">{schema.granteeProfile.departmentTitle} : </strong>
                      {schema.granteeProfile.department}
                    </Col> */}

                    <Col xs={18} sm={19} md={24} className="text-col">
                      <strong className="title">{schema.granteeProfile.addressTitle} : </strong>
                      {schema.granteeProfile.address}
                    </Col>

                    <Col xs={18} sm={19} md={24} className="text-col">
                      <strong className="title">{schema.granteeProfile.telephoneTitle} : </strong>
                      {schema.granteeProfile.telephone}
                    </Col>

                    <Col xs={18} sm={19} md={24} className="text-col">
                      <strong className="title">{schema.granteeProfile.emailTitle} : </strong>
                      {schema.granteeProfile.email}
                    </Col>
                  </Row>
                </Panel>
              </Content>

              <Content className="grantee-profile-info__content">
                <div
                  ref={(section) => {
                    setSectionA(section)
                  }}
                >
                  <TableBackList schema={schema.blacklist} header={schema.blacklistStatus} />
                </div>
                {/* <Panel bordered bodyFill style={{ padding: 10, height: '48%' }}>
                  <Row style={{ paddingTop: '5%', paddingBottom: '5%' }}>
                    <Col xs={18} sm={19} md={24} className="text-col">
                      <strong>{schema.granteeProfile.checkValidity}</strong>
                    </Col>
                    <Col xs={12}>
                      <Col xs={18} sm={19} md={24} className="text-col">
                        <strong className="title">{schema.granteeProfile.checkStatusTitle}</strong>
                      </Col>
                      <Col xs={18} sm={19} md={24} className="text-col"> */}
                {/* <text style={(nomalTextStyle, past)}>{schema.granteeProfile.checkStatus}</span> */}
                {/* </Col>
                    </Col>
                    <Col xs={12}>
                      <Col xs={18} sm={19} md={24} className="text-col">
                        <strong className="title">{schema.granteeProfile.modifyDateTitle}</strong>
                      </Col>
                      <Col xs={18} sm={19} md={24} className="text-col">
                        <span>{schema.granteeProfile.modifyDate}</span>
                      </Col>
                    </Col>
                  </Row>
                </Panel> */}

                <Panel bordered bodyFill style={{ padding: 10, height: '60%', marginTop: 5.5 }}>
                  <Row style={{ paddingTop: '5%', paddingBottom: '5%' }}>
                    <Col xs={18} sm={19} md={24} className="text-col">
                      <strong>{schema.granteeProfile.checkCOIValidity}</strong>
                    </Col>
                    <Col xs={12}>
                      <Col xs={18} sm={19} md={24} className="text-col">
                        <strong className="title">
                          {schema.granteeProfile.checkCOIStatusTitle}
                        </strong>
                      </Col>
                      <Col xs={18} sm={19} md={24} className="text-col">
                        {/* <text style={(nomalTextStyle, notpast)}>ไม่ผ่านการตรวจสอบ</span> */}
                      </Col>
                    </Col>
                    <Col xs={12}>
                      <Col xs={18} sm={19} md={24} className="text-col">
                        <strong className="title">
                          {schema.granteeProfile.modifyCOIDateTitle}
                        </strong>
                      </Col>
                      <Col xs={18} sm={19} md={24} className="text-col">
                        <span>{schema.granteeProfile.modifyCOIDate}</span>
                      </Col>
                    </Col>
                  </Row>
                </Panel>
              </Content>
            </Container>
          </Container>

          <Footer>
            {/* <div
              ref={(section) => {
                setSectionA(section)
              }}
            >
              <TableBackList schema={schema.blacklist} header={schema.blacklistStatus} />
            </div> */}
            <div>
              {schema?.evaluateResults && (
                <Panel header={'ผลการประเมิน'} bordered collapsible defaultExpanded>
                  {schema.evaluateResults.map((item) => {
                    return (
                      <p>
                        {item.value}% {item.label}
                      </p>
                    )
                  })}
                </Panel>
              )}
            </div>
            <div
              ref={(section) => {
                setSectionB(section)
              }}
            >
              <TableProjectSummary
                schema={schema.tableProjectSummary}
                header={schema.progressSummary}
              />
            </div>
            <div
              ref={(section) => {
                setSectionC(section)
              }}
            >
              <TableProjectHistoryForResponsible
                schema={schema.tableProjectHistory}
                header={schema.progressHistory}
              />
            </div>
          </Footer>
        </Container>
      </Panel>
    </>
  )
}
